import React from 'react'
import { styles } from './index.sass'
import { ContentGenerator } from '../../components/contentGenerator/ContentGenerator'
import { refineBlog } from '../../api/contentGeneration'
import { loadUser } from '../../utils/storage'  

export const ApeironBlog = () => {
  const handleLoadTestData = (setContentHtml) => {
    const testContent = `
      <h1>The Power of Mindfulness Meditation</h1>
      <p>In today's fast-paced world, finding moments of peace and quiet can feel like a luxury. However, practicing mindfulness meditation doesn't require hours of sitting in silence. Just a few minutes a day can have profound effects on your mental and physical well-being.</p>
      
      <h2>What is Mindfulness?</h2>
      <p>Mindfulness is the practice of being present in the moment, observing your thoughts and feelings without judgment. It's about paying attention to your breath, your body, and the world around you in a way that brings clarity and calm.</p>
      
      <h2>Benefits of Mindfulness Meditation</h2>
      <ul>
        <li><strong>Reduced Stress:</strong> Studies show mindfulness can lower cortisol levels and reduce anxiety</li>
        <li><strong>Improved Focus:</strong> Regular practice enhances concentration and cognitive function</li>
        <li><strong>Better Sleep:</strong> Mindfulness techniques can help you fall asleep faster and sleep more soundly</li>
        <li><strong>Emotional Regulation:</strong> You'll learn to respond to stressors more effectively</li>
      </ul>
      
      <h2>Getting Started</h2>
      <p>Begin with just 5 minutes a day. Find a quiet space, sit comfortably, and focus on your breath. When your mind wanders, gently bring it back to the present moment. Consistency is key - even short daily sessions can yield significant benefits.</p>
      
      <p>Remember, mindfulness is a practice, not a perfect. Be patient with yourself and enjoy the journey towards greater peace and awareness.</p>
    `
    setContentHtml(testContent)
  }

  const handleGenerate = async (topic, regenerate, onStepUpdate) => {
    if (!topic.trim()) {
      throw new Error('Please enter a topic for blog generation')
    }

    return new Promise((resolve, reject) => {
      const url = `${process.env.REACT_APP_ML_API_ENDPOINT}/api/ml/generate-blog-stream`
      const user = loadUser()
      const eventSource = new EventSource(`${url}?topic=${encodeURIComponent(topic)}&regenerate=${true}&expert_name=${user && user.full_name ? user.full_name : ''}`)

      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data)
        
        if (data.step !== undefined && onStepUpdate) {
          onStepUpdate(data)
        } else if (data.status === 'success') {
          eventSource.close()
          resolve({
            success: true,
            content_html: data.content_html,
            message: 'Blog generated successfully!'
          })
        } else if (data.status === 'error') {
          eventSource.close()
          reject(new Error(data.message || 'Failed to generate blog'))
        }
      }

      eventSource.onerror = () => {
        eventSource.close()
        reject(new Error('Stream connection error'))
      }
    })
  }

  return (
    <div className={styles}>
      <ContentGenerator
        title="Blog Content Generator"
        inputPlaceholder="Enter topic for blog generation"
        generateButtonText="Generate Blog"
        regenerateButtonText="Regenerate"
        editButtonText="Refine with AI"
        loadTestDataButtonText="Load Test Data"
        onGenerate={handleGenerate}
        onRefine={refineBlog}
        onLoadTestData={handleLoadTestData}
      />
    </div>
  )
}
